// src/components/inventory/PrintableQRCode.js
// --- UPDATE (Inventory MOW+ v2) ----------------------------------------------------------
//   • Label shows SKU, location and category as well as the name, with the FlowSense MOW+ /
//     Ministry of Works line; "small" size for shelf bins.
//   • Works without a QR image (new item not yet saved) — prints the SKU in large type instead.
//   • Supplier reads supplier_name too (the API field).
// --- END UPDATE ---------------------------------------------------------------------------
import React from 'react';
import { Box, Image, Text, VStack } from '@chakra-ui/react';

const PrintableQRCode = React.forwardRef(({ item, qrCodeDataUrl, size = 'standard' }, ref) => { // --- UPDATE: + size
  if (!item) return null;
  // --- UPDATE
  const small = size === 'small';
  const sku = item.sku || `ITM-${String(item.id).padStart(4, '0')}`;
  // --- END UPDATE

  return (
    <Box
      ref={ref}
      className="print-container"
      p={small ? 2 : 4} // --- UPDATE
      borderWidth="1px"
      borderRadius="lg"
      m={small ? 2 : 4} // --- UPDATE
      w={small ? '200px' : '300px'} // --- UPDATE
      bg="white"
      color="black"
    >
      <VStack spacing={small ? 1 : 4}>
        <Text fontSize={small ? 'md' : 'xl'} fontWeight="bold" textAlign="center">
          {item.name}
        </Text>
        {qrCodeDataUrl ? ( // --- UPDATE: no QR yet → large SKU
        <Image
          src={qrCodeDataUrl}
          alt={`${item.name} QR Code`}
          boxSize={small ? '140px' : '250px'}
          objectFit="contain"
        />
        ) : (
          <Box borderWidth="2px" borderStyle="dashed" borderColor="gray.400" borderRadius="md" px={3} py={small ? 4 : 10} w="full" textAlign="center">
            <Text fontFamily="mono" fontWeight="900" fontSize={small ? 'xl' : '3xl'} letterSpacing="wider">{sku}</Text>
            <Text fontSize="2xs" color="gray.500">QR code not generated yet</Text>
          </Box>
        )}
        {/* --- UPDATE: SKU / location / category */}
        <Text fontFamily="mono" fontSize={small ? 'xs' : 'md'} fontWeight="700">{sku}</Text>
        {(item.warehouse_location || item.location || item.category_name || item.category) && (
          <Text fontSize="xs" color="gray.700" textAlign="center">{[item.warehouse_location || item.location, item.category_name || item.category].filter(Boolean).join(' · ')}</Text>
        )}
        <Text fontSize="sm" color="gray.600">
          ID: {item.id} | Supplier: {item.supplier || item.supplier_name || 'N/A'}
        </Text>
        <Text fontSize="2xs" color="gray.500" letterSpacing="wider" textTransform="uppercase">FlowSense MOW+ · Ministry of Works</Text>
        {/* --- END UPDATE */}
      </VStack>
    </Box>
  );
});

PrintableQRCode.displayName = 'PrintableQRCode'; // --- UPDATE
export default PrintableQRCode; // ✅ default export
